import { Star } from "lucide-react";

export const Stars = ({ size = 16, className = "" }) => (
  <span className={`inline-flex gap-0.5 text-gold ${className}`} aria-label="4.5 out of 5 stars">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} size={size} fill="currentColor" strokeWidth={0} />
    ))}
  </span>
);

export const ReviewCard = ({ review }) => (
  <figure
    data-testid={`review-card-${review.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className="flex h-full flex-col rounded-2xl bg-white border border-line p-7 md:p-8"
  >
    <span className="font-display text-5xl leading-none text-gold" aria-hidden="true">
      &ldquo;
    </span>
    <blockquote className="mt-2 flex-1 text-base leading-relaxed text-charcoal/80">
      {review.quote}
    </blockquote>
    <figcaption className="mt-6 flex items-center justify-between gap-4">
      <div>
        <p className="font-semibold text-sm text-charcoal">{review.name}</p>
        <p className="text-xs text-charcoal/50 mt-0.5">Google Review</p>
      </div>
      <Stars size={14} />
    </figcaption>
  </figure>
);
